import React from 'react';
import cn from 'classnames';
import Text from '@tamagoshi/core/Text';
import Button from '@tamagoshi/core/Button';
import { useBreakpoints } from '@tamagoshi/core/MediaQuery';
import SendIcon from '@tamagoshi/icons/Send';
import { getTranslations } from '@translations';
import { getFooterContext } from '@context';
import { useBodyOverflow } from '@hooks';

import styles from './styles/index.module.scss';

const NewsletterButton = () => {
  const translations = getTranslations();
  const { isB2B, emailAddress, baseUrl, onSubmitEmail } = getFooterContext();
  const { setBodyOverflow, releaseBodyOverflow } = useBodyOverflow();
  const breakpoints = useBreakpoints();
  const buttonClassName = cn({
    [styles.inputButton]: true,
    [styles.submitButton]: breakpoints.sm,
    [styles.submitIconButton]: breakpoints.xs,
  });
  const onSubmit = event => {
    event.preventDefault();
    setBodyOverflow('hidden');
    onSubmitEmail(emailAddress, baseUrl, releaseBodyOverflow);
  };

  return (
    <Button
      type="submit"
      theme={isB2B ? 'proMarketing' : 'primary'}
      size="lg"
      className={buttonClassName}
      onClick={onSubmit}
    >
      {breakpoints.xs ? (
        <SendIcon />
      ) : (
        <Text type="body2" weight="semiBold">
          {translations('footer.contact.newsletter.submit.text')}
        </Text>
      )}
    </Button>
  );
};

NewsletterButton.displayName = 'NewsletterButton';

export default NewsletterButton;
